export default __webpack_public_path__ + "static/media/CORE_gltd_c2.8470674c.png";